import { ISigningAppointmentRescheduleResponse } from '../../../types/signingAppointment/ISigningAppointmentRescheduleResponse';
import { useMemo } from 'react';
import { isDateGreaterThan } from '../../timeHelpers';
import { ISigningAppointmentResponse } from '../../../types/signingAppointment/ISigningAppointmentResponse';

/*
 * determines which reschedule of a signing appointment is the most recent.
 *  if a SA has zero reschedules, returns null.
 * */
export const useFindMostRecentReschedule = (signingAppointment?: ISigningAppointmentResponse) => {
  const mostRecentReschedule: ISigningAppointmentRescheduleResponse | null = useMemo(() => {
    if (!signingAppointment) return null;
    if (!signingAppointment.reschedules.length) {
      return null;
    }
    return signingAppointment.reschedules.reduce((latestReschedule, currentReschedule) => {
      if (isDateGreaterThan(latestReschedule.updatedAt, currentReschedule.updatedAt)) {
        return latestReschedule;
      }
      return currentReschedule;
    });
  }, [signingAppointment]);
  return mostRecentReschedule;
};
